<script>
  import { _ } from "svelte-i18n";
  import { fade, blur } from "svelte/transition";
  import { createEventDispatcher, onMount } from "svelte";
  const dispatch = createEventDispatcher();
  import Select from "svelte-select";
  import { selectedOrgDTO } from "../ui-store";
  import { removeAccents, isIntegerValue, CookiesApi } from "../utils/helpers";
  import { getUserProjects, getProjectArticles } from "../services/project360Service.js"; 

  export let obligatory = false;
  export let disabled = false;
  export let locked = false;
  export let touched = false;
  export let successful = false;
  export let value = null;
  
  let measurementValue = {
    selectedProject: null,
    selectedArticles: [],
  };

  let projects = []
  ;

  let articles = [
  ];

  let articleMaxQuantities = {};
  $: console.log(articleMaxQuantities);

  let sum = 0;
  function computeSum() {
    sum = 0;

    if (measurementValue.selectedArticles && measurementValue.selectedArticles.length > 0) {
      measurementValue.selectedArticles.forEach((article) => {
        sum += article.totalPrice || 0;
      });
    }
  }

  $: if (measurementValue.selectedProject && measurementValue.selectedArticles && measurementValue.selectedArticles.length && measurementValue.selectedArticles.length > 0) {
    dispatch("getValue", {
      value: measurementValue,
    });
  }

  const handleSelectProject = async () => {
    articles = await getProjectArticles($selectedOrgDTO.id, measurementValue.selectedProject.id);
    articleMaxQuantities = articles.reduce(function(map, obj) {
      map[obj.code] = obj.quantity;
      return map;
    }, {});
    //reset quantities
    articles = articles.map(item => {item.quantity = 0; return item;});
  }

  const handleClearProject = () => {
    articles = [];
    articleMaxQuantities = {};
    measurementValue = {
      selectedProject: null,
      selectedArticles: [],
    };
    dispatch("getValue", {
      value: null,
    });
  }

  onMount(async () => {

    //retrieve a user's projects
    projects = await getUserProjects($selectedOrgDTO.id);
    // console.log(projects);
    measurementValue = {
      selectedProject: null,
      selectedArticles: [],
    };

    if (articles && articles.length > 0) {
      articles.forEach((article) => {
        article.quantityTouched = false;
        article.quantitySuccessful = null;

        article.unitPrice = article.unitPrice;
        article.quantity = article.quantity;
        article.totalPrice = article.unitPrice * article.quantity;
      });

      computeSum();
    }
  });

</script>

<div class="field">
  <label for={"Έργα"} class="label">
    Έργα
  </label>
  <div>
    <Select
      id={"Έργα"}
      items={projects}
      bind:value={measurementValue.selectedProject}
      optionIdentifier="id"
      getOptionLabel={(option) => option.title}
      getSelectionLabel={(option) => option.title}
      itemFilter={(label, filterText, option) =>
        removeAccents(label).includes(removeAccents(filterText))}
      on:select={handleSelectProject}
      on:clear={handleClearProject}
      isDisabled={disabled || locked}
      containerClasses={touched
        ? successful
          ? "is-success-select"
          : " is-danger-select"
        : ""}
      containerStyles={disabled || locked
        ? "border: none; background-color: transparent; resize: none; outline: none;padding: 0; color: black !important;"
        : ""}
      placeholder=""
      showChevron={true}
    />
  </div>
</div>

<div class="field">
  <label for={"Άρθρα"} class="label">
    {"Άρθρα"}
  </label>
  <Select
    id={"Άρθρα"}
    isMulti={true}
    items={articles}
    bind:value={measurementValue.selectedArticles}
    optionIdentifier="code"
    getOptionLabel={(option) => option.title}
    getSelectionLabel={(option) => option.title}
    itemFilter={(label, filterText, option) =>
      removeAccents(label).includes(removeAccents(filterText))}
    on:select={(e) => {
      computeSum();
      dispatch("select", e);
    }}
    on:clear={(e) => {
      dispatch("clear", e);
    }}
    isDisabled={!measurementValue.selectedProject || disabled || locked}
    containerClasses={touched
      ? successful
        ? "is-success-select"
        : "is-danger-select"
      : ""}
    containerStyles={!measurementValue.selectedProject ?
      "display: none;" :
      disabled || locked
      ? "border: none; background-color: transparent; resize: none; outline: none;padding: 0; color: black !important;"
      : ""}
    placeholder=""
    showChevron={true}
  />
</div>
  {#if !measurementValue.selectedProject }
      <p transition:fade class="help has-text-grey is-italic">Παρακαλώ επιλέξτε έργο</p>
  {/if}

{#if measurementValue.selectedArticles && measurementValue.selectedArticles.length > 0}
  <div class="field">
    <table id="data-table">
      <thead>
        <tr>
          <th>Τίτλος</th>
          <th>Κωδικός</th>
          <th>Μονάδα μέτρησης</th>
          <th>Τιμή</th>
          <th>Ποσότητα</th>
          <th>Κόστος</th>
        </tr>
      </thead>
      <tbody>
        {#each measurementValue.selectedArticles as article}
          <tr>
            <td>{article.title}</td>
            <td>{article.code}</td>
            <td>{article.measurementUnit}</td>
            <td>{article.unitPrice}</td>
            <td>
              {#if disabled || locked}
                {article.quantity}
              {:else}
                <input
                  bind:value={article.quantity}
                  type="text"
                  class="input {article.quantityTouched
                    ? article.quantitySuccessful
                      ? 'is-success'
                      : 'is-danger'
                    : ''}"
                  on:input={() => {
                    article.quantityTouched = true;

                    // Convert the input value string to a number
                    const quantityNumber = Number(article.quantity);

                    if (isIntegerValue(quantityNumber)) {
                      article.quantity = quantityNumber; // update article.quantity as a number
                      article.quantitySuccessful = true;
                      article.totalPrice = article.unitPrice * article.quantity;
                      computeSum();
                    } else {
                      article.quantitySuccessful = false;
                      article.totalPrice = "NaN";
                      sum = "NaN";
                    }
                  }}
                />
              {/if}
              {#if article.quantity > articleMaxQuantities[article.code]}
                <p transition:fade class="help has-text-danger is-italic">Η τιμή υπερβαίνει τη διαθέσιμη ποσότητα!</p>
              {/if}
            </td>
            <td>
              {Math.round((article.totalPrice + Number.EPSILON) * 100) / 100}
            </td>
          </tr>
        {/each}
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>Σύνολο: {Math.round((sum + Number.EPSILON) * 100) / 100}</td>
        </tr>
      </tfoot>
    </table>
  </div>
{/if}

<style>
  #data-table {
    width: 100%;
    border-collapse: collapse;
  }

  #data-table th,
  #data-table td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
    vertical-align: middle;
  }

  #data-table tfoot {
    font-weight: bold;
    background-color: #f2f2f2;
    text-align: center;
    vertical-align: middle;
  }
</style>
